import { UploadOutlined } from "@ant-design/icons"
import { PAGINATION } from "@config/constant"
import { useAppDispatch } from "@hook/useAppDispatch"
import { useAppSelector } from "@hook/useAppSelector"
import { callImportDeliveryCase, callGetListDeliveryCase, changeVisibleDeliveryCaseImport } from "@reducer/version2/delivery-case.reducer"
import { trans } from "@resources/localization"
import { Button, Col, Form, message, Row, Space } from "antd"
import { isEmpty } from "lodash"
import React from "react"
import { useSearchParams } from "react-router-dom"

type Props = {
    setIsUpload: (data: boolean) => void
}
export const FormImport: React.FC<Props> = ({ setIsUpload }) => {
    const [searchParams] = useSearchParams()
    const [formRef] = Form.useForm()
    const dispatch = useAppDispatch()
    const loadingImport = useAppSelector((state) => state.deliveryCase.loadingImport)

    const handleImportDeliveryCase = (values: { file: File }) => {
        if (!values.file) {
            message.error(trans("delivery_case.required_file"))
        } else {
            dispatch(
                callImportDeliveryCase({
                    file: values.file,
                })
            ).then((result: any) => {
                if (result?.payload?.status === 201) {
                    if (isEmpty(result?.payload?.data?.errors)) {
                        message.success(`${trans("contact.noti_succ")} ${result?.payload?.data?.successCount} ${trans("delivery_case.status_import")}`)
                        setTimeout(() => {
                            dispatch(changeVisibleDeliveryCaseImport(false))
                        }, 500)
                    } else {
                        setIsUpload(true)
                    }
                    if (result?.payload?.data?.successCount >= 1) {
                        // fetch list contact when api success
                        dispatch(callGetListDeliveryCase({
                            ...Object.fromEntries(searchParams.entries()),
                            pageSize: searchParams.has("pageSize") ? Number(searchParams.get("pageSize")) : PAGINATION.DEFAULT_PAGE_SIZE,
                            sort: "createdAt:DESC",
                        }))
                    }
                } else {
                    message.error(result?.payload?.response?.data?.message || trans("message.fail"))
                }
            })
        }
    }
    return (
        <Form
            form={formRef}
            onFinish={handleImportDeliveryCase}
            layout="vertical">
            <Row gutter={[0, 15]}>
                <Col span={24}>
                    <Form.Item
                        name="file"
                        hidden
                    />
                    <Button
                        icon={<UploadOutlined />}
                        onClick={() => document.getElementById("uploadFile")?.click()}>
                        {trans("campaign.choose_file")}
                    </Button>
                    <input
                        hidden
                        type="file"
                        id="uploadFile"
                        accept="text/csv"
                        value=""
                        onChange={(e) => {
                            formRef.setFieldsValue({
                                file: e.target.files ? e.target.files[0] : "",
                            })
                        }}
                    />
                    <Form.Item
                        noStyle
                        shouldUpdate={(pre, next) => pre.file !== next.file}>
                        {({ getFieldValue }) =>
                            getFieldValue("file") && (
                                <div className="flex">
                                    <p className="m-0 mt-1 ml-2">{getFieldValue("file")?.name}</p>
                                    <Button
                                        type="link"
                                        icon={<i className="fa-solid fa-trash"></i>}
                                        onClick={() => {
                                            formRef.setFieldsValue({
                                                file: "",
                                            })
                                        }}></Button>
                                </div>
                            )
                        }
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <a
                        href={require("@resources/files/Delivery_Case_Import_Template.csv")}
                        rel="noreferrer"
                        download="Delivery_Case_Import_Template.csv"
                        type="link">
                        {trans("contact.download_import_template")}
                    </a>
                </Col>
            </Row>
            <Row justify="end">
                <Space>
                    <Button
                        loading={loadingImport}
                        type="default"
                        onClick={() => {
                            setIsUpload(false)
                            dispatch(changeVisibleDeliveryCaseImport(false))
                        }}>
                        {trans("button.cancel_button")}
                    </Button>
                    <Button
                        loading={loadingImport}
                        type="primary"
                        htmlType="submit">
                        {trans("button.save")}
                    </Button>
                </Space>
            </Row>
        </Form>
    )
}
